<div class="w-100 mt-2 rounded rounded-8 panel">
  <p-panel [toggleable]="true"
           [style]="{width: '100%', marginBottom: '20px'}"
           expandIcon="pi pi-chevron-up"
           collapseIcon="pi pi-chevron-down">
    <ng-template pTemplate="header">
      <div class="w-100 bg-white br p-4" style="box-sizing: border-box;">
        <div class="d-flex align-items-center justify-content-between mb-4" style="height: 40px;">
          <div class="d-flex flex-row align-items-center justify-content-between w-50" style="height: 90%;">
            <div class="d-flex align-items-center" style="height: 100%;">
              <div class="left-border"></div>
              <span class="title">🗓️ Drift Frequency Calendar</span>
            </div>
            <span class="p-input-icon-left" style="height: 100%;">
              <i class="pi pi-search hide"></i>
              <input type="text" placeholder="Search by name of ID" class="search-input w-100 hide" pInputText />
            </span>
          </div>
          <ng-container>
            <div class="row mb-2" style="padding-right:1.5rem;">
              <div class="col d-center">
                <div style="width: 130px;"
                     class="d-center gap-2 stats-container">
                  <span style="background-color:#CABDFF" class="d-center stats-icon">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.74088 10.8335C9.13412 10.8335 11.0742 8.8934 11.0742 6.50016C11.0742 4.10693 9.13412 2.16683 6.74088 2.16683C4.34765 2.16683 2.40755 4.10693 2.40755 6.50016C2.40755 8.8934 4.34765 10.8335 6.74088 10.8335ZM6.74088 11.9168C9.73243 11.9168 12.1576 9.4917 12.1576 6.50016C12.1576 3.50862 9.73243 1.0835 6.74088 1.0835C3.74934 1.0835 1.32422 3.50862 1.32422 6.50016C1.32422 9.4917 3.74934 11.9168 6.74088 11.9168Z"
                            fill="black" />
                      <path d="M7.28223 4.33317C7.28223 4.03402 7.03971 3.7915 6.74056 3.7915C6.44141 3.7915 6.19889 4.03402 6.19889 4.33317L6.19889 5.95817H4.57389C4.27474 5.95817 4.03223 6.20068 4.03223 6.49984C4.03223 6.79899 4.27474 7.0415 4.57389 7.0415H6.19889V8.6665C6.19889 8.96566 6.44141 9.20817 6.74056 9.20817C7.03971 9.20817 7.28223 8.96566 7.28223 8.6665L7.28223 7.0415H8.90723C9.20638 7.0415 9.44889 6.79899 9.44889 6.49984C9.44889 6.20068 9.20638 5.95817 8.90723 5.95817H7.28223L7.28223 4.33317Z"
                            fill="black" />
                    </svg>
                  </span>
                  <span>Added</span>
                  <span class="stats-count">{{ getTotal(chartData[0]) }}</span>
                </div>
              </div>
              <div class="col d-center">
                <div style="width: 130px;"
                     class="d-center gap-2 stats-container">
                  <span style="background-color:#CABDFF" class="d-center stats-icon">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.74088 10.8335C9.13412 10.8335 11.0742 8.8934 11.0742 6.50016C11.0742 4.10693 9.13412 2.16683 6.74088 2.16683C4.34765 2.16683 2.40755 4.10693 2.40755 6.50016C2.40755 8.8934 4.34765 10.8335 6.74088 10.8335ZM6.74088 11.9168C9.73243 11.9168 12.1576 9.4917 12.1576 6.50016C12.1576 3.50862 9.73243 1.0835 6.74088 1.0835C3.74934 1.0835 1.32422 3.50862 1.32422 6.50016C1.32422 9.4917 3.74934 11.9168 6.74088 11.9168Z"
                            fill="black" />
                      <path d="M7.28223 4.33317C7.28223 4.03402 7.03971 3.7915 6.74056 3.7915C6.44141 3.7915 6.19889 4.03402 6.19889 4.33317L6.19889 5.95817H4.57389C4.27474 5.95817 4.03223 6.20068 4.03223 6.49984C4.03223 6.79899 4.27474 7.0415 4.57389 7.0415H6.19889V8.6665C6.19889 8.96566 6.44141 9.20817 6.74056 9.20817C7.03971 9.20817 7.28223 8.96566 7.28223 8.6665L7.28223 7.0415H8.90723C9.20638 7.0415 9.44889 6.79899 9.44889 6.49984C9.44889 6.20068 9.20638 5.95817 8.90723 5.95817H7.28223L7.28223 4.33317Z"
                            fill="black" />
                    </svg>
                  </span>
                  <span>Archived</span>
                  <span class="stats-count">{{ getTotal(chartData[1]) }}</span>
                </div>
              </div>
              <div class="col d-center">
                <div style="width: 130px;"
                     class="d-center gap-2 stats-container">
                  <span style="background-color:#CABDFF" class="d-center stats-icon">
                    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.74088 10.8335C9.13412 10.8335 11.0742 8.8934 11.0742 6.50016C11.0742 4.10693 9.13412 2.16683 6.74088 2.16683C4.34765 2.16683 2.40755 4.10693 2.40755 6.50016C2.40755 8.8934 4.34765 10.8335 6.74088 10.8335ZM6.74088 11.9168C9.73243 11.9168 12.1576 9.4917 12.1576 6.50016C12.1576 3.50862 9.73243 1.0835 6.74088 1.0835C3.74934 1.0835 1.32422 3.50862 1.32422 6.50016C1.32422 9.4917 3.74934 11.9168 6.74088 11.9168Z"
                            fill="black" />
                      <path d="M7.28223 4.33317C7.28223 4.03402 7.03971 3.7915 6.74056 3.7915C6.44141 3.7915 6.19889 4.03402 6.19889 4.33317L6.19889 5.95817H4.57389C4.27474 5.95817 4.03223 6.20068 4.03223 6.49984C4.03223 6.79899 4.27474 7.0415 4.57389 7.0415H6.19889V8.6665C6.19889 8.96566 6.44141 9.20817 6.74056 9.20817C7.03971 9.20817 7.28223 8.96566 7.28223 8.6665L7.28223 7.0415H8.90723C9.20638 7.0415 9.44889 6.79899 9.44889 6.49984C9.44889 6.20068 9.20638 5.95817 8.90723 5.95817H7.28223L7.28223 4.33317Z"
                            fill="black" />
                    </svg>
                  </span>
                  <span>Removed</span>
                  <span class="stats-count">{{ getTotal(chartData[2]) }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <div class="w-65 bg-white br p-4" style="box-sizing: border-box;">
      <div class="d-flex flex-column scrollerbar">
        <div class="row w-100 mb-2 header-title">

          <div class="flex justify-between items-center mb-3">
            <div class="flex items-center gap-2">
              <p-checkbox [(ngModel)]="showLegend" [binary]="true"></p-checkbox>
              <label class="text-gray-700 dark:text-gray-200">Show Legend</label>
            </div>

            <div class="flex items-center gap-2">
              <p-checkbox [(ngModel)]="isDark" [binary]="true"></p-checkbox>
              <label class="text-gray-700 dark:text-gray-200">Dark Mode</label>
            </div>
          </div>

          <div class="chart-container">
            <ngx-charts-heat-map [view]="view"
                                 [scheme]="colorScheme"
                                 [results]="chartData"
                                 [xAxis]="true"
                                 [yAxis]="true"
                                 [showXAxisLabel]="true"
                                 [showYAxisLabel]="false"
                                 [xAxisLabel]="'Date / Week'"
                                 [yAxisLabel]="'Week'"
                                 [gradient]="true"
                                 (select)="onHeatmapSelect($event)">
            </ngx-charts-heat-map>

            <!-- Sidebar container (unchanged) -->
            <p-sidebar [(visible)]="showDriftDetails" position="right" [baseZIndex]="10000" [style]="{width: '35vw'}">
              <h3 class="mb-3">Schema Drifts — {{ selectedCell?.name }}</h3>

              <div *ngIf="selectedDrifts.length > 0; else noData">
                <div *ngFor="let drift of selectedDrifts" class="drift-entry mb-2 p-2 border-bottom flex align-items-center">
                  <!-- Colored status dot -->
                  <span class="status-dot me-2"
                        [ngClass]="{
                                    'dot-added': drift.action === 'Added',
                                    'dot-archived': drift.action === 'Archived',
                                    'dot-removed': drift.action === 'Removed'
                                  }">
                  </span>

                  <!-- Drift details -->
                  <div class="flex flex-column">
                    <b>{{ drift.table }}</b>
                    <span class="text-sm text-muted">{{ drift.action }}</span>
                    <span class="text-xs text-gray-500">{{ drift.date | date:'medium' }}</span>
                  </div>
                </div>
              </div>

              <ng-template #noData>
                <p>No schema drifts for this period.</p>
              </ng-template>
            </p-sidebar>
          </div>
        </div>
      </div>
    </div>
  </p-panel>
</div>
